/**
 * (Группа 5) Подписки и биллинг — cross-tenant список + продления + финансы.
 *
 * Реальные данные частично есть:
 *   - REAL POST /v1/admin/tenants/{id}/extend-subscription (ручное продление)
 *   - REAL GET  /v1/admin/tenants/{id}/subscription-extensions (история)
 *   - REAL invoices/payments/subscriptions API (@hsc/api-client)
 * Сводный cross-tenant список и revenue-дашборд — TODO backend.
 */
import { PageStub } from '../../shared/PageStub.js';

export function SubscriptionsPage(): JSX.Element {
  return (
    <PageStub
      testId="subscriptions-page"
      title="Подписки и биллинг"
      description="Cross-tenant подписки, ручные продления, счета, транзакции T-Bank, выручка."
      sections={[
        'Список подписок (active / trial / past-due) с фильтрами',
        'Карточка подписки: период, автопродление, история платежей',
        'Ручное продление: дни (7/30/60/90/custom), причина ≥20 символов, вариант счёта',
        'История ручных продлений (cross-tenant)',
        'Счета · Транзакции T-Bank · Возвраты и chargeback',
        'Revenue-дашборд: MRR/ARR, когорты, churn, ARPU',
      ]}
      dataSource="REAL extend-subscription + subscription-extensions + invoices/payments; cross-tenant список и revenue — TODO backend"
    />
  );
}
